// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"b382f312","633":"c3fc60db"}[chunkId] + ".chunk.js";
};